/* eslint-disable */
import React from "react";
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext();

const CustomThemeProvider = ({ children }) => {
	const [isDarkMode, setIsDarkMode] = useState(
		localStorage?.getItem("custom-theme") == "light" ? false : true
	);
	const [theme, setTheme] = useState(
		localStorage.getItem("custom-theme") ?? "dark"
	);

	useEffect(() => {
		setTheme(isDarkMode ? "dark" : "light");
		localStorage.setItem("custom-theme", isDarkMode ? "dark" : "light");
	}, [isDarkMode]);

	const switchTheme = () => {
		setIsDarkMode((previousValue) => !previousValue);
	};

	const contextValue = useMemo(
		() => ({
			isDarkMode,
			switchTheme,
		}),
		[isDarkMode]
	);

	return (
		<ThemeContext.Provider value={contextValue}>
			<div className={`${theme}-theme`}>{children}</div>
		</ThemeContext.Provider>
	);
};

export const useTheme = () => {
	return useContext(ThemeContext);
};
export default CustomThemeProvider;
